export enum ISO3166_1_Alpha2Code {
  AF = "AF",
  AX = "AX",
  AL = "AL",
  DZ = "DZ",
  AS = "AS",
  AD = "AD",
  AO = "AO",
  AI = "AI",
  AQ = "AQ",
  AG = "AG",
  AR = "AR",
  AM = "AM",
  AW = "AW",
  AU = "AU",
  AT = "AT",
  AZ = "AZ",
  BS = "BS",
  BH = "BH",
  BD = "BD",
  BB = "BB",
  BY = "BY",
  BE = "BE",
  BZ = "BZ",
  BJ = "BJ",
  BM = "BM",
  BT = "BT",
  BO = "BO",
  BA = "BA",
  BW = "BW",
  BV = "BV",
  BR = "BR",
  IO = "IO",
  VG = "VG",
  BN = "BN",
  BG = "BG",
  BF = "BF",
  BI = "BI",
  KH = "KH",
  CM = "CM",
  CA = "CA",
  CV = "CV",
  BQ = "BQ",
  KY = "KY",
  CF = "CF",
  TD = "TD",
  CL = "CL",
  CN = "CN",
  CX = "CX",
  CC = "CC",
  CO = "CO",
  KM = "KM",
  CK = "CK",
  CR = "CR",
  CI = "CI",
  HR = "HR",
  CU = "CU",
  CW = "CW",
  CY = "CY",
  CZ = "CZ",
  DK = "DK",
  DJ = "DJ",
  DM = "DM",
  DO = "DO",
  CD = "CD",
  EC = "EC",
  EG = "EG",
  SV = "SV",
  GQ = "GQ",
  ER = "ER",
  EE = "EE",
  SZ = "SZ",
  ET = "ET",
  FK = "FK",
  FO = "FO",
  FJ = "FJ",
  FI = "FI",
  FR = "FR",
  GF = "GF",
  PF = "PF",
  TF = "TF",
  GA = "GA",
  GM = "GM",
  GE = "GE",
  DE = "DE",
  GH = "GH",
  GI = "GI",
  GR = "GR",
  GL = "GL",
  GD = "GD",
  GP = "GP",
  GU = "GU",
  GT = "GT",
  GG = "GG",
  GN = "GN",
  GW = "GW",
  GY = "GY",
  HT = "HT",
  HM = "HM",
  HN = "HN",
  HK = "HK",
  HU = "HU",
  IS = "IS",
  IN = "IN",
  ID = "ID",
  IR = "IR",
  IQ = "IQ",
  IE = "IE",
  IM = "IM",
  IL = "IL",
  IT = "IT",
  JM = "JM",
  JP = "JP",
  JE = "JE",
  JO = "JO",
  KZ = "KZ",
  KE = "KE",
  KI = "KI",
  XK = "XK",
  KW = "KW",
  KG = "KG",
  LA = "LA",
  LV = "LV",
  LB = "LB",
  LS = "LS",
  LR = "LR",
  LY = "LY",
  LI = "LI",
  LT = "LT",
  LU = "LU",
  MO = "MO",
  MG = "MG",
  MW = "MW",
  MY = "MY",
  MV = "MV",
  ML = "ML",
  MT = "MT",
  MH = "MH",
  MQ = "MQ",
  MR = "MR",
  MU = "MU",
  YT = "YT",
  MX = "MX",
  FM = "FM",
  MD = "MD",
  MC = "MC",
  MN = "MN",
  ME = "ME",
  MS = "MS",
  MA = "MA",
  MZ = "MZ",
  MM = "MM",
  NA = "NA",
  NR = "NR",
  NP = "NP",
  NL = "NL",
  NC = "NC",
  NZ = "NZ",
  NI = "NI",
  NE = "NE",
  NG = "NG",
  NU = "NU",
  NF = "NF",
  KP = "KP",
  MK = "MK",
  MP = "MP",
  NO = "NO",
  OM = "OM",
  PK = "PK",
  PW = "PW",
  PS = "PS",
  PA = "PA",
  PG = "PG",
  PY = "PY",
  PE = "PE",
  PH = "PH",
  PN = "PN",
  PL = "PL",
  PT = "PT",
  PR = "PR",
  QA = "QA",
  CG = "CG",
  RE = "RE",
  RO = "RO",
  RU = "RU",
  RW = "RW",
  BL = "BL",
  SH = "SH",
  KN = "KN",
  LC = "LC",
  MF = "MF",
  PM = "PM",
  VC = "VC",
  WS = "WS",
  SM = "SM",
  ST = "ST",
  SA = "SA",
  SN = "SN",
  RS = "RS",
  SC = "SC",
  SL = "SL",
  SG = "SG",
  SX = "SX",
  SK = "SK",
  SI = "SI",
  SB = "SB",
  SO = "SO",
  ZA = "ZA",
  GS = "GS",
  KR = "KR",
  SS = "SS",
  ES = "ES",
  LK = "LK",
  SD = "SD",
  SR = "SR",
  SJ = "SJ",
  SE = "SE",
  CH = "CH",
  SY = "SY",
  TW = "TW",
  TJ = "TJ",
  TZ = "TZ",
  TH = "TH",
  TL = "TL",
  TG = "TG",
  TK = "TK",
  TO = "TO",
  TT = "TT",
  TN = "TN",
  TR = "TR",
  TM = "TM",
  TC = "TC",
  TV = "TV",
  UG = "UG",
  UA = "UA",
  AE = "AE",
  GB = "GB",
  US = "US",
  UM = "UM",
  VI = "VI",
  UY = "UY",
  UZ = "UZ",
  VU = "VU",
  VA = "VA",
  VE = "VE",
  VN = "VN",
  WF = "WF",
  EH = "EH",
  YE = "YE",
  ZM = "ZM",
  ZW = "ZW"
}

export enum ISO3166_1_Alpha2ByCountry {
  afghanistan = ISO3166_1_Alpha2Code.AF,
  aland_islands = ISO3166_1_Alpha2Code.AX,
  albania = ISO3166_1_Alpha2Code.AL,
  algeria = ISO3166_1_Alpha2Code.DZ,
  american_samoa = ISO3166_1_Alpha2Code.AS,
  andorra = ISO3166_1_Alpha2Code.AD,
  angola = ISO3166_1_Alpha2Code.AO,
  anguilla = ISO3166_1_Alpha2Code.AI,
  antarctica = ISO3166_1_Alpha2Code.AQ,
  antigua_barbuda = ISO3166_1_Alpha2Code.AG,
  argentina = ISO3166_1_Alpha2Code.AR,
  armenia = ISO3166_1_Alpha2Code.AM,
  aruba = ISO3166_1_Alpha2Code.AW,
  australia = ISO3166_1_Alpha2Code.AU,
  austria = ISO3166_1_Alpha2Code.AT,
  azerbaijan = ISO3166_1_Alpha2Code.AZ,
  bahamas = ISO3166_1_Alpha2Code.BS,
  bahrain = ISO3166_1_Alpha2Code.BH,
  bangladesh = ISO3166_1_Alpha2Code.BD,
  barbados = ISO3166_1_Alpha2Code.BB,
  belarus = ISO3166_1_Alpha2Code.BY,
  belgium = ISO3166_1_Alpha2Code.BE,
  belize = ISO3166_1_Alpha2Code.BZ,
  benin = ISO3166_1_Alpha2Code.BJ,
  bermuda = ISO3166_1_Alpha2Code.BM,
  bhutan = ISO3166_1_Alpha2Code.BT,
  bolivia = ISO3166_1_Alpha2Code.BO,
  bosnia_herzegovina = ISO3166_1_Alpha2Code.BA,
  botswana = ISO3166_1_Alpha2Code.BW,
  bouvet_island = ISO3166_1_Alpha2Code.BV,
  brazil = ISO3166_1_Alpha2Code.BR,
  british_indian_ocean_territory = ISO3166_1_Alpha2Code.IO,
  british_virgin_islands = ISO3166_1_Alpha2Code.VG,
  brunei = ISO3166_1_Alpha2Code.BN,
  bulgaria = ISO3166_1_Alpha2Code.BG,
  burkina_faso = ISO3166_1_Alpha2Code.BF,
  burundi = ISO3166_1_Alpha2Code.BI,
  cambodia = ISO3166_1_Alpha2Code.KH,
  cameroon = ISO3166_1_Alpha2Code.CM,
  canada = ISO3166_1_Alpha2Code.CA,
  cape_verde = ISO3166_1_Alpha2Code.CV,
  bonaire_sint_eustatius_saba = ISO3166_1_Alpha2Code.BQ,
  cayman_islands = ISO3166_1_Alpha2Code.KY,
  central_african_republic = ISO3166_1_Alpha2Code.CF,
  chad = ISO3166_1_Alpha2Code.TD,
  chile = ISO3166_1_Alpha2Code.CL,
  china = ISO3166_1_Alpha2Code.CN,
  christmas_island = ISO3166_1_Alpha2Code.CX,
  cocos_keeling_islands = ISO3166_1_Alpha2Code.CC,
  colombia = ISO3166_1_Alpha2Code.CO,
  comoros = ISO3166_1_Alpha2Code.KM,
  cook_islands = ISO3166_1_Alpha2Code.CK,
  costa_rica = ISO3166_1_Alpha2Code.CR,
  cote_divoire = ISO3166_1_Alpha2Code.CI,
  croatia = ISO3166_1_Alpha2Code.HR,
  cuba = ISO3166_1_Alpha2Code.CU,
  curacao = ISO3166_1_Alpha2Code.CW,
  cyprus = ISO3166_1_Alpha2Code.CY,
  czechia = ISO3166_1_Alpha2Code.CZ,
  denmark = ISO3166_1_Alpha2Code.DK,
  djibouti = ISO3166_1_Alpha2Code.DJ,
  dominica = ISO3166_1_Alpha2Code.DM,
  dominican_republic = ISO3166_1_Alpha2Code.DO,
  dr_congo = ISO3166_1_Alpha2Code.CD,
  ecuador = ISO3166_1_Alpha2Code.EC,
  egypt = ISO3166_1_Alpha2Code.EG,
  el_salvador = ISO3166_1_Alpha2Code.SV,
  equatorial_guinea = ISO3166_1_Alpha2Code.GQ,
  eritrea = ISO3166_1_Alpha2Code.ER,
  estonia = ISO3166_1_Alpha2Code.EE,
  eswatini = ISO3166_1_Alpha2Code.SZ,
  ethiopia = ISO3166_1_Alpha2Code.ET,
  falkland_islands = ISO3166_1_Alpha2Code.FK,
  faroe_islands = ISO3166_1_Alpha2Code.FO,
  fiji = ISO3166_1_Alpha2Code.FJ,
  finland = ISO3166_1_Alpha2Code.FI,
  france = ISO3166_1_Alpha2Code.FR,
  french_guiana = ISO3166_1_Alpha2Code.GF,
  french_polynesia = ISO3166_1_Alpha2Code.PF,
  french_southern_antarctic_lands = ISO3166_1_Alpha2Code.TF,
  gabon = ISO3166_1_Alpha2Code.GA,
  gambia = ISO3166_1_Alpha2Code.GM,
  georgia = ISO3166_1_Alpha2Code.GE,
  germany = ISO3166_1_Alpha2Code.DE,
  ghana = ISO3166_1_Alpha2Code.GH,
  gibraltar = ISO3166_1_Alpha2Code.GI,
  greece = ISO3166_1_Alpha2Code.GR,
  greenland = ISO3166_1_Alpha2Code.GL,
  grenada = ISO3166_1_Alpha2Code.GD,
  guadeloupe = ISO3166_1_Alpha2Code.GP,
  guam = ISO3166_1_Alpha2Code.GU,
  guatemala = ISO3166_1_Alpha2Code.GT,
  guernsey = ISO3166_1_Alpha2Code.GG,
  guinea = ISO3166_1_Alpha2Code.GN,
  guinea_bissau = ISO3166_1_Alpha2Code.GW,
  guyana = ISO3166_1_Alpha2Code.GY,
  haiti = ISO3166_1_Alpha2Code.HT,
  heard_island_mcdonald_islands = ISO3166_1_Alpha2Code.HM,
  honduras = ISO3166_1_Alpha2Code.HN,
  hong_kong = ISO3166_1_Alpha2Code.HK,
  hungary = ISO3166_1_Alpha2Code.HU,
  iceland = ISO3166_1_Alpha2Code.IS,
  india = ISO3166_1_Alpha2Code.IN,
  indonesia = ISO3166_1_Alpha2Code.ID,
  iran = ISO3166_1_Alpha2Code.IR,
  iraq = ISO3166_1_Alpha2Code.IQ,
  ireland = ISO3166_1_Alpha2Code.IE,
  isle_of_man = ISO3166_1_Alpha2Code.IM,
  israel = ISO3166_1_Alpha2Code.IL,
  italy = ISO3166_1_Alpha2Code.IT,
  jamaica = ISO3166_1_Alpha2Code.JM,
  japan = ISO3166_1_Alpha2Code.JP,
  jersey = ISO3166_1_Alpha2Code.JE,
  jordan = ISO3166_1_Alpha2Code.JO,
  kazakhstan = ISO3166_1_Alpha2Code.KZ,
  kenya = ISO3166_1_Alpha2Code.KE,
  kiribati = ISO3166_1_Alpha2Code.KI,
  kosovo = ISO3166_1_Alpha2Code.XK,
  kuwait = ISO3166_1_Alpha2Code.KW,
  kyrgyzstan = ISO3166_1_Alpha2Code.KG,
  laos = ISO3166_1_Alpha2Code.LA,
  latvia = ISO3166_1_Alpha2Code.LV,
  lebanon = ISO3166_1_Alpha2Code.LB,
  lesotho = ISO3166_1_Alpha2Code.LS,
  liberia = ISO3166_1_Alpha2Code.LR,
  libya = ISO3166_1_Alpha2Code.LY,
  liechtenstein = ISO3166_1_Alpha2Code.LI,
  lithuania = ISO3166_1_Alpha2Code.LT,
  luxembourg = ISO3166_1_Alpha2Code.LU,
  macau = ISO3166_1_Alpha2Code.MO,
  madagascar = ISO3166_1_Alpha2Code.MG,
  malawi = ISO3166_1_Alpha2Code.MW,
  malaysia = ISO3166_1_Alpha2Code.MY,
  maldives = ISO3166_1_Alpha2Code.MV,
  mali = ISO3166_1_Alpha2Code.ML,
  malta = ISO3166_1_Alpha2Code.MT,
  marshall_islands = ISO3166_1_Alpha2Code.MH,
  martinique = ISO3166_1_Alpha2Code.MQ,
  mauritania = ISO3166_1_Alpha2Code.MR,
  mauritius = ISO3166_1_Alpha2Code.MU,
  mayotte = ISO3166_1_Alpha2Code.YT,
  mexico = ISO3166_1_Alpha2Code.MX,
  micronesia = ISO3166_1_Alpha2Code.FM,
  moldova = ISO3166_1_Alpha2Code.MD,
  monaco = ISO3166_1_Alpha2Code.MC,
  mongolia = ISO3166_1_Alpha2Code.MN,
  montenegro = ISO3166_1_Alpha2Code.ME,
  montserrat = ISO3166_1_Alpha2Code.MS,
  morocco = ISO3166_1_Alpha2Code.MA,
  mozambique = ISO3166_1_Alpha2Code.MZ,
  myanmar = ISO3166_1_Alpha2Code.MM,
  namibia = ISO3166_1_Alpha2Code.NA,
  nauru = ISO3166_1_Alpha2Code.NR,
  nepal = ISO3166_1_Alpha2Code.NP,
  netherlands = ISO3166_1_Alpha2Code.NL,
  new_caledonia = ISO3166_1_Alpha2Code.NC,
  new_zealand = ISO3166_1_Alpha2Code.NZ,
  nicaragua = ISO3166_1_Alpha2Code.NI,
  niger = ISO3166_1_Alpha2Code.NE,
  nigeria = ISO3166_1_Alpha2Code.NG,
  niue = ISO3166_1_Alpha2Code.NU,
  norfolk_island = ISO3166_1_Alpha2Code.NF,
  north_korea = ISO3166_1_Alpha2Code.KP,
  north_macedonia = ISO3166_1_Alpha2Code.MK,
  northern_mariana_islands = ISO3166_1_Alpha2Code.MP,
  norway = ISO3166_1_Alpha2Code.NO,
  oman = ISO3166_1_Alpha2Code.OM,
  pakistan = ISO3166_1_Alpha2Code.PK,
  palau = ISO3166_1_Alpha2Code.PW,
  palestine = ISO3166_1_Alpha2Code.PS,
  panama = ISO3166_1_Alpha2Code.PA,
  papua_new_guinea = ISO3166_1_Alpha2Code.PG,
  paraguay = ISO3166_1_Alpha2Code.PY,
  peru = ISO3166_1_Alpha2Code.PE,
  philippines = ISO3166_1_Alpha2Code.PH,
  pitcairn_islands = ISO3166_1_Alpha2Code.PN,
  poland = ISO3166_1_Alpha2Code.PL,
  portugal = ISO3166_1_Alpha2Code.PT,
  puerto_rico = ISO3166_1_Alpha2Code.PR,
  qatar = ISO3166_1_Alpha2Code.QA,
  republic_of_congo = ISO3166_1_Alpha2Code.CG,
  reunion = ISO3166_1_Alpha2Code.RE,
  romania = ISO3166_1_Alpha2Code.RO,
  russia = ISO3166_1_Alpha2Code.RU,
  rwanda = ISO3166_1_Alpha2Code.RW,
  st_barthelemy = ISO3166_1_Alpha2Code.BL,
  st_helena_ascension_tristan_da_cunha = ISO3166_1_Alpha2Code.SH,
  st_kitts_nevis = ISO3166_1_Alpha2Code.KN,
  st_lucia = ISO3166_1_Alpha2Code.LC,
  st_martin = ISO3166_1_Alpha2Code.MF,
  st_pierre_miquelon = ISO3166_1_Alpha2Code.PM,
  st_vincent_grenadines = ISO3166_1_Alpha2Code.VC,
  samoa = ISO3166_1_Alpha2Code.WS,
  san_marino = ISO3166_1_Alpha2Code.SM,
  sao_tome_principe = ISO3166_1_Alpha2Code.ST,
  saudi_arabia = ISO3166_1_Alpha2Code.SA,
  senegal = ISO3166_1_Alpha2Code.SN,
  serbia = ISO3166_1_Alpha2Code.RS,
  seychelles = ISO3166_1_Alpha2Code.SC,
  sierra_leone = ISO3166_1_Alpha2Code.SL,
  singapore = ISO3166_1_Alpha2Code.SG,
  sint_maarten = ISO3166_1_Alpha2Code.SX,
  slovakia = ISO3166_1_Alpha2Code.SK,
  slovenia = ISO3166_1_Alpha2Code.SI,
  solomon_islands = ISO3166_1_Alpha2Code.SB,
  somalia = ISO3166_1_Alpha2Code.SO,
  south_africa = ISO3166_1_Alpha2Code.ZA,
  south_georgia = ISO3166_1_Alpha2Code.GS,
  south_korea = ISO3166_1_Alpha2Code.KR,
  south_sudan = ISO3166_1_Alpha2Code.SS,
  spain = ISO3166_1_Alpha2Code.ES,
  sri_lanka = ISO3166_1_Alpha2Code.LK,
  sudan = ISO3166_1_Alpha2Code.SD,
  suriname = ISO3166_1_Alpha2Code.SR,
  svalbard_jan_mayen = ISO3166_1_Alpha2Code.SJ,
  sweden = ISO3166_1_Alpha2Code.SE,
  switzerland = ISO3166_1_Alpha2Code.CH,
  syria = ISO3166_1_Alpha2Code.SY,
  taiwan = ISO3166_1_Alpha2Code.TW,
  tajikistan = ISO3166_1_Alpha2Code.TJ,
  tanzania = ISO3166_1_Alpha2Code.TZ,
  thailand = ISO3166_1_Alpha2Code.TH,
  timor_leste = ISO3166_1_Alpha2Code.TL,
  togo = ISO3166_1_Alpha2Code.TG,
  tokelau = ISO3166_1_Alpha2Code.TK,
  tonga = ISO3166_1_Alpha2Code.TO,
  trinidad_tobago = ISO3166_1_Alpha2Code.TT,
  tunisia = ISO3166_1_Alpha2Code.TN,
  turkey = ISO3166_1_Alpha2Code.TR,
  turkmenistan = ISO3166_1_Alpha2Code.TM,
  turks_caicos_islands = ISO3166_1_Alpha2Code.TC,
  tuvalu = ISO3166_1_Alpha2Code.TV,
  uganda = ISO3166_1_Alpha2Code.UG,
  ukraine = ISO3166_1_Alpha2Code.UA,
  united_arab_emirates = ISO3166_1_Alpha2Code.AE,
  united_kingdom = ISO3166_1_Alpha2Code.GB,
  united_states = ISO3166_1_Alpha2Code.US,
  united_states_minor_outlying_islands = ISO3166_1_Alpha2Code.UM,
  united_states_virgin_islands = ISO3166_1_Alpha2Code.VI,
  uruguay = ISO3166_1_Alpha2Code.UY,
  uzbekistan = ISO3166_1_Alpha2Code.UZ,
  vanuatu = ISO3166_1_Alpha2Code.VU,
  vatican_city = ISO3166_1_Alpha2Code.VA,
  venezuela = ISO3166_1_Alpha2Code.VE,
  vietnam = ISO3166_1_Alpha2Code.VN,
  wallis_futuna = ISO3166_1_Alpha2Code.WF,
  western_sahara = ISO3166_1_Alpha2Code.EH,
  yemen = ISO3166_1_Alpha2Code.YE,
  zambia = ISO3166_1_Alpha2Code.ZM,
  zimbabwe = ISO3166_1_Alpha2Code.ZW
}

export type ISO3166_1_Alpha2 = `${ISO3166_1_Alpha2Code}` | ISO3166_1_Alpha2Code | ISO3166_1_Alpha2ByCountry;

export enum ISO3166_1_Alpha3Code {
  AFG = "AFG",
  ALA = "ALA",
  ALB = "ALB",
  DZA = "DZA",
  ASM = "ASM",
  AND = "AND",
  AGO = "AGO",
  AIA = "AIA",
  ATA = "ATA",
  ATG = "ATG",
  ARG = "ARG",
  ARM = "ARM",
  ABW = "ABW",
  AUS = "AUS",
  AUT = "AUT",
  AZE = "AZE",
  BHS = "BHS",
  BHR = "BHR",
  BGD = "BGD",
  BRB = "BRB",
  BLR = "BLR",
  BEL = "BEL",
  BLZ = "BLZ",
  BEN = "BEN",
  BMU = "BMU",
  BTN = "BTN",
  BOL = "BOL",
  BIH = "BIH",
  BWA = "BWA",
  BVT = "BVT",
  BRA = "BRA",
  IOT = "IOT",
  VGB = "VGB",
  BRN = "BRN",
  BGR = "BGR",
  BFA = "BFA",
  BDI = "BDI",
  KHM = "KHM",
  CMR = "CMR",
  CAN = "CAN",
  CPV = "CPV",
  BES = "BES",
  CYM = "CYM",
  CAF = "CAF",
  TCD = "TCD",
  CHL = "CHL",
  CHN = "CHN",
  CXR = "CXR",
  CCK = "CCK",
  COL = "COL",
  COM = "COM",
  COK = "COK",
  CRI = "CRI",
  CIV = "CIV",
  HRV = "HRV",
  CUB = "CUB",
  CUW = "CUW",
  CYP = "CYP",
  CZE = "CZE",
  DNK = "DNK",
  DJI = "DJI",
  DMA = "DMA",
  DOM = "DOM",
  COD = "COD",
  ECU = "ECU",
  EGY = "EGY",
  SLV = "SLV",
  GNQ = "GNQ",
  ERI = "ERI",
  EST = "EST",
  SWZ = "SWZ",
  ETH = "ETH",
  FLK = "FLK",
  FRO = "FRO",
  FJI = "FJI",
  FIN = "FIN",
  FRA = "FRA",
  GUF = "GUF",
  PYF = "PYF",
  ATF = "ATF",
  GAB = "GAB",
  GMB = "GMB",
  GEO = "GEO",
  DEU = "DEU",
  GHA = "GHA",
  GIB = "GIB",
  GRC = "GRC",
  GRL = "GRL",
  GRD = "GRD",
  GLP = "GLP",
  GUM = "GUM",
  GTM = "GTM",
  GGY = "GGY",
  GIN = "GIN",
  GNB = "GNB",
  GUY = "GUY",
  HTI = "HTI",
  HMD = "HMD",
  HND = "HND",
  HKG = "HKG",
  HUN = "HUN",
  ISL = "ISL",
  IND = "IND",
  IDN = "IDN",
  IRN = "IRN",
  IRQ = "IRQ",
  IRL = "IRL",
  IMN = "IMN",
  ISR = "ISR",
  ITA = "ITA",
  JAM = "JAM",
  JPN = "JPN",
  JEY = "JEY",
  JOR = "JOR",
  KAZ = "KAZ",
  KEN = "KEN",
  KIR = "KIR",
  UNK = "UNK",
  KWT = "KWT",
  KGZ = "KGZ",
  LAO = "LAO",
  LVA = "LVA",
  LBN = "LBN",
  LSO = "LSO",
  LBR = "LBR",
  LBY = "LBY",
  LIE = "LIE",
  LTU = "LTU",
  LUX = "LUX",
  MAC = "MAC",
  MDG = "MDG",
  MWI = "MWI",
  MYS = "MYS",
  MDV = "MDV",
  MLI = "MLI",
  MLT = "MLT",
  MHL = "MHL",
  MTQ = "MTQ",
  MRT = "MRT",
  MUS = "MUS",
  MYT = "MYT",
  MEX = "MEX",
  FSM = "FSM",
  MDA = "MDA",
  MCO = "MCO",
  MNG = "MNG",
  MNE = "MNE",
  MSR = "MSR",
  MAR = "MAR",
  MOZ = "MOZ",
  MMR = "MMR",
  NAM = "NAM",
  NRU = "NRU",
  NPL = "NPL",
  NLD = "NLD",
  NCL = "NCL",
  NZL = "NZL",
  NIC = "NIC",
  NER = "NER",
  NGA = "NGA",
  NIU = "NIU",
  NFK = "NFK",
  PRK = "PRK",
  MKD = "MKD",
  MNP = "MNP",
  NOR = "NOR",
  OMN = "OMN",
  PAK = "PAK",
  PLW = "PLW",
  PSE = "PSE",
  PAN = "PAN",
  PNG = "PNG",
  PRY = "PRY",
  PER = "PER",
  PHL = "PHL",
  PCN = "PCN",
  POL = "POL",
  PRT = "PRT",
  PRI = "PRI",
  QAT = "QAT",
  COG = "COG",
  REU = "REU",
  ROU = "ROU",
  RUS = "RUS",
  RWA = "RWA",
  BLM = "BLM",
  SHN = "SHN",
  KNA = "KNA",
  LCA = "LCA",
  MAF = "MAF",
  SPM = "SPM",
  VCT = "VCT",
  WSM = "WSM",
  SMR = "SMR",
  STP = "STP",
  SAU = "SAU",
  SEN = "SEN",
  SRB = "SRB",
  SYC = "SYC",
  SLE = "SLE",
  SGP = "SGP",
  SXM = "SXM",
  SVK = "SVK",
  SVN = "SVN",
  SLB = "SLB",
  SOM = "SOM",
  ZAF = "ZAF",
  SGS = "SGS",
  KOR = "KOR",
  SSD = "SSD",
  ESP = "ESP",
  LKA = "LKA",
  SDN = "SDN",
  SUR = "SUR",
  SJM = "SJM",
  SWE = "SWE",
  CHE = "CHE",
  SYR = "SYR",
  TWN = "TWN",
  TJK = "TJK",
  TZA = "TZA",
  THA = "THA",
  TLS = "TLS",
  TGO = "TGO",
  TKL = "TKL",
  TON = "TON",
  TTO = "TTO",
  TUN = "TUN",
  TUR = "TUR",
  TKM = "TKM",
  TCA = "TCA",
  TUV = "TUV",
  UGA = "UGA",
  UKR = "UKR",
  ARE = "ARE",
  GBR = "GBR",
  USA = "USA",
  UMI = "UMI",
  VIR = "VIR",
  URY = "URY",
  UZB = "UZB",
  VUT = "VUT",
  VAT = "VAT",
  VEN = "VEN",
  VNM = "VNM",
  WLF = "WLF",
  ESH = "ESH",
  YEM = "YEM",
  ZMB = "ZMB",
  ZWE = "ZWE"
}

export enum ISO3166_1_Alpha3ByCountry {
  afghanistan = ISO3166_1_Alpha3Code.AFG,
  aland_islands = ISO3166_1_Alpha3Code.ALA,
  albania = ISO3166_1_Alpha3Code.ALB,
  algeria = ISO3166_1_Alpha3Code.DZA,
  american_samoa = ISO3166_1_Alpha3Code.ASM,
  andorra = ISO3166_1_Alpha3Code.AND,
  angola = ISO3166_1_Alpha3Code.AGO,
  anguilla = ISO3166_1_Alpha3Code.AIA,
  antarctica = ISO3166_1_Alpha3Code.ATA,
  antigua_barbuda = ISO3166_1_Alpha3Code.ATG,
  argentina = ISO3166_1_Alpha3Code.ARG,
  armenia = ISO3166_1_Alpha3Code.ARM,
  aruba = ISO3166_1_Alpha3Code.ABW,
  australia = ISO3166_1_Alpha3Code.AUS,
  austria = ISO3166_1_Alpha3Code.AUT,
  azerbaijan = ISO3166_1_Alpha3Code.AZE,
  bahamas = ISO3166_1_Alpha3Code.BHS,
  bahrain = ISO3166_1_Alpha3Code.BHR,
  bangladesh = ISO3166_1_Alpha3Code.BGD,
  barbados = ISO3166_1_Alpha3Code.BRB,
  belarus = ISO3166_1_Alpha3Code.BLR,
  belgium = ISO3166_1_Alpha3Code.BEL,
  belize = ISO3166_1_Alpha3Code.BLZ,
  benin = ISO3166_1_Alpha3Code.BEN,
  bermuda = ISO3166_1_Alpha3Code.BMU,
  bhutan = ISO3166_1_Alpha3Code.BTN,
  bolivia = ISO3166_1_Alpha3Code.BOL,
  bosnia_herzegovina = ISO3166_1_Alpha3Code.BIH,
  botswana = ISO3166_1_Alpha3Code.BWA,
  bouvet_island = ISO3166_1_Alpha3Code.BVT,
  brazil = ISO3166_1_Alpha3Code.BRA,
  british_indian_ocean_territory = ISO3166_1_Alpha3Code.IOT,
  british_virgin_islands = ISO3166_1_Alpha3Code.VGB,
  brunei = ISO3166_1_Alpha3Code.BRN,
  bulgaria = ISO3166_1_Alpha3Code.BGR,
  burkina_faso = ISO3166_1_Alpha3Code.BFA,
  burundi = ISO3166_1_Alpha3Code.BDI,
  cambodia = ISO3166_1_Alpha3Code.KHM,
  cameroon = ISO3166_1_Alpha3Code.CMR,
  canada = ISO3166_1_Alpha3Code.CAN,
  cape_verde = ISO3166_1_Alpha3Code.CPV,
  bonaire_sint_eustatius_saba = ISO3166_1_Alpha3Code.BES,
  cayman_islands = ISO3166_1_Alpha3Code.CYM,
  central_african_republic = ISO3166_1_Alpha3Code.CAF,
  chad = ISO3166_1_Alpha3Code.TCD,
  chile = ISO3166_1_Alpha3Code.CHL,
  china = ISO3166_1_Alpha3Code.CHN,
  christmas_island = ISO3166_1_Alpha3Code.CXR,
  cocos_keeling_islands = ISO3166_1_Alpha3Code.CCK,
  colombia = ISO3166_1_Alpha3Code.COL,
  comoros = ISO3166_1_Alpha3Code.COM,
  cook_islands = ISO3166_1_Alpha3Code.COK,
  costa_rica = ISO3166_1_Alpha3Code.CRI,
  cote_divoire = ISO3166_1_Alpha3Code.CIV,
  croatia = ISO3166_1_Alpha3Code.HRV,
  cuba = ISO3166_1_Alpha3Code.CUB,
  curacao = ISO3166_1_Alpha3Code.CUW,
  cyprus = ISO3166_1_Alpha3Code.CYP,
  czechia = ISO3166_1_Alpha3Code.CZE,
  denmark = ISO3166_1_Alpha3Code.DNK,
  djibouti = ISO3166_1_Alpha3Code.DJI,
  dominica = ISO3166_1_Alpha3Code.DMA,
  dominican_republic = ISO3166_1_Alpha3Code.DOM,
  dr_congo = ISO3166_1_Alpha3Code.COD,
  ecuador = ISO3166_1_Alpha3Code.ECU,
  egypt = ISO3166_1_Alpha3Code.EGY,
  el_salvador = ISO3166_1_Alpha3Code.SLV,
  equatorial_guinea = ISO3166_1_Alpha3Code.GNQ,
  eritrea = ISO3166_1_Alpha3Code.ERI,
  estonia = ISO3166_1_Alpha3Code.EST,
  eswatini = ISO3166_1_Alpha3Code.SWZ,
  ethiopia = ISO3166_1_Alpha3Code.ETH,
  falkland_islands = ISO3166_1_Alpha3Code.FLK,
  faroe_islands = ISO3166_1_Alpha3Code.FRO,
  fiji = ISO3166_1_Alpha3Code.FJI,
  finland = ISO3166_1_Alpha3Code.FIN,
  france = ISO3166_1_Alpha3Code.FRA,
  french_guiana = ISO3166_1_Alpha3Code.GUF,
  french_polynesia = ISO3166_1_Alpha3Code.PYF,
  french_southern_antarctic_lands = ISO3166_1_Alpha3Code.ATF,
  gabon = ISO3166_1_Alpha3Code.GAB,
  gambia = ISO3166_1_Alpha3Code.GMB,
  georgia = ISO3166_1_Alpha3Code.GEO,
  germany = ISO3166_1_Alpha3Code.DEU,
  ghana = ISO3166_1_Alpha3Code.GHA,
  gibraltar = ISO3166_1_Alpha3Code.GIB,
  greece = ISO3166_1_Alpha3Code.GRC,
  greenland = ISO3166_1_Alpha3Code.GRL,
  grenada = ISO3166_1_Alpha3Code.GRD,
  guadeloupe = ISO3166_1_Alpha3Code.GLP,
  guam = ISO3166_1_Alpha3Code.GUM,
  guatemala = ISO3166_1_Alpha3Code.GTM,
  guernsey = ISO3166_1_Alpha3Code.GGY,
  guinea = ISO3166_1_Alpha3Code.GIN,
  guinea_bissau = ISO3166_1_Alpha3Code.GNB,
  guyana = ISO3166_1_Alpha3Code.GUY,
  haiti = ISO3166_1_Alpha3Code.HTI,
  heard_island_mcdonald_islands = ISO3166_1_Alpha3Code.HMD,
  honduras = ISO3166_1_Alpha3Code.HND,
  hong_kong = ISO3166_1_Alpha3Code.HKG,
  hungary = ISO3166_1_Alpha3Code.HUN,
  iceland = ISO3166_1_Alpha3Code.ISL,
  india = ISO3166_1_Alpha3Code.IND,
  indonesia = ISO3166_1_Alpha3Code.IDN,
  iran = ISO3166_1_Alpha3Code.IRN,
  iraq = ISO3166_1_Alpha3Code.IRQ,
  ireland = ISO3166_1_Alpha3Code.IRL,
  isle_of_man = ISO3166_1_Alpha3Code.IMN,
  israel = ISO3166_1_Alpha3Code.ISR,
  italy = ISO3166_1_Alpha3Code.ITA,
  jamaica = ISO3166_1_Alpha3Code.JAM,
  japan = ISO3166_1_Alpha3Code.JPN,
  jersey = ISO3166_1_Alpha3Code.JEY,
  jordan = ISO3166_1_Alpha3Code.JOR,
  kazakhstan = ISO3166_1_Alpha3Code.KAZ,
  kenya = ISO3166_1_Alpha3Code.KEN,
  kiribati = ISO3166_1_Alpha3Code.KIR,
  kosovo = ISO3166_1_Alpha3Code.UNK,
  kuwait = ISO3166_1_Alpha3Code.KWT,
  kyrgyzstan = ISO3166_1_Alpha3Code.KGZ,
  laos = ISO3166_1_Alpha3Code.LAO,
  latvia = ISO3166_1_Alpha3Code.LVA,
  lebanon = ISO3166_1_Alpha3Code.LBN,
  lesotho = ISO3166_1_Alpha3Code.LSO,
  liberia = ISO3166_1_Alpha3Code.LBR,
  libya = ISO3166_1_Alpha3Code.LBY,
  liechtenstein = ISO3166_1_Alpha3Code.LIE,
  lithuania = ISO3166_1_Alpha3Code.LTU,
  luxembourg = ISO3166_1_Alpha3Code.LUX,
  macau = ISO3166_1_Alpha3Code.MAC,
  madagascar = ISO3166_1_Alpha3Code.MDG,
  malawi = ISO3166_1_Alpha3Code.MWI,
  malaysia = ISO3166_1_Alpha3Code.MYS,
  maldives = ISO3166_1_Alpha3Code.MDV,
  mali = ISO3166_1_Alpha3Code.MLI,
  malta = ISO3166_1_Alpha3Code.MLT,
  marshall_islands = ISO3166_1_Alpha3Code.MHL,
  martinique = ISO3166_1_Alpha3Code.MTQ,
  mauritania = ISO3166_1_Alpha3Code.MRT,
  mauritius = ISO3166_1_Alpha3Code.MUS,
  mayotte = ISO3166_1_Alpha3Code.MYT,
  mexico = ISO3166_1_Alpha3Code.MEX,
  micronesia = ISO3166_1_Alpha3Code.FSM,
  moldova = ISO3166_1_Alpha3Code.MDA,
  monaco = ISO3166_1_Alpha3Code.MCO,
  mongolia = ISO3166_1_Alpha3Code.MNG,
  montenegro = ISO3166_1_Alpha3Code.MNE,
  montserrat = ISO3166_1_Alpha3Code.MSR,
  morocco = ISO3166_1_Alpha3Code.MAR,
  mozambique = ISO3166_1_Alpha3Code.MOZ,
  myanmar = ISO3166_1_Alpha3Code.MMR,
  namibia = ISO3166_1_Alpha3Code.NAM,
  nauru = ISO3166_1_Alpha3Code.NRU,
  nepal = ISO3166_1_Alpha3Code.NPL,
  netherlands = ISO3166_1_Alpha3Code.NLD,
  new_caledonia = ISO3166_1_Alpha3Code.NCL,
  new_zealand = ISO3166_1_Alpha3Code.NZL,
  nicaragua = ISO3166_1_Alpha3Code.NIC,
  niger = ISO3166_1_Alpha3Code.NER,
  nigeria = ISO3166_1_Alpha3Code.NGA,
  niue = ISO3166_1_Alpha3Code.NIU,
  norfolk_island = ISO3166_1_Alpha3Code.NFK,
  north_korea = ISO3166_1_Alpha3Code.PRK,
  north_macedonia = ISO3166_1_Alpha3Code.MKD,
  northern_mariana_islands = ISO3166_1_Alpha3Code.MNP,
  norway = ISO3166_1_Alpha3Code.NOR,
  oman = ISO3166_1_Alpha3Code.OMN,
  pakistan = ISO3166_1_Alpha3Code.PAK,
  palau = ISO3166_1_Alpha3Code.PLW,
  palestine = ISO3166_1_Alpha3Code.PSE,
  panama = ISO3166_1_Alpha3Code.PAN,
  papua_new_guinea = ISO3166_1_Alpha3Code.PNG,
  paraguay = ISO3166_1_Alpha3Code.PRY,
  peru = ISO3166_1_Alpha3Code.PER,
  philippines = ISO3166_1_Alpha3Code.PHL,
  pitcairn_islands = ISO3166_1_Alpha3Code.PCN,
  poland = ISO3166_1_Alpha3Code.POL,
  portugal = ISO3166_1_Alpha3Code.PRT,
  puerto_rico = ISO3166_1_Alpha3Code.PRI,
  qatar = ISO3166_1_Alpha3Code.QAT,
  republic_of_congo = ISO3166_1_Alpha3Code.COG,
  reunion = ISO3166_1_Alpha3Code.REU,
  romania = ISO3166_1_Alpha3Code.ROU,
  russia = ISO3166_1_Alpha3Code.RUS,
  rwanda = ISO3166_1_Alpha3Code.RWA,
  st_barthelemy = ISO3166_1_Alpha3Code.BLM,
  st_helena_ascension_tristan_da_cunha = ISO3166_1_Alpha3Code.SHN,
  st_kitts_nevis = ISO3166_1_Alpha3Code.KNA,
  st_lucia = ISO3166_1_Alpha3Code.LCA,
  st_martin = ISO3166_1_Alpha3Code.MAF,
  st_pierre_miquelon = ISO3166_1_Alpha3Code.SPM,
  st_vincent_grenadines = ISO3166_1_Alpha3Code.VCT,
  samoa = ISO3166_1_Alpha3Code.WSM,
  san_marino = ISO3166_1_Alpha3Code.SMR,
  sao_tome_principe = ISO3166_1_Alpha3Code.STP,
  saudi_arabia = ISO3166_1_Alpha3Code.SAU,
  senegal = ISO3166_1_Alpha3Code.SEN,
  serbia = ISO3166_1_Alpha3Code.SRB,
  seychelles = ISO3166_1_Alpha3Code.SYC,
  sierra_leone = ISO3166_1_Alpha3Code.SLE,
  singapore = ISO3166_1_Alpha3Code.SGP,
  sint_maarten = ISO3166_1_Alpha3Code.SXM,
  slovakia = ISO3166_1_Alpha3Code.SVK,
  slovenia = ISO3166_1_Alpha3Code.SVN,
  solomon_islands = ISO3166_1_Alpha3Code.SLB,
  somalia = ISO3166_1_Alpha3Code.SOM,
  south_africa = ISO3166_1_Alpha3Code.ZAF,
  south_georgia = ISO3166_1_Alpha3Code.SGS,
  south_korea = ISO3166_1_Alpha3Code.KOR,
  south_sudan = ISO3166_1_Alpha3Code.SSD,
  spain = ISO3166_1_Alpha3Code.ESP,
  sri_lanka = ISO3166_1_Alpha3Code.LKA,
  sudan = ISO3166_1_Alpha3Code.SDN,
  suriname = ISO3166_1_Alpha3Code.SUR,
  svalbard_jan_mayen = ISO3166_1_Alpha3Code.SJM,
  sweden = ISO3166_1_Alpha3Code.SWE,
  switzerland = ISO3166_1_Alpha3Code.CHE,
  syria = ISO3166_1_Alpha3Code.SYR,
  taiwan = ISO3166_1_Alpha3Code.TWN,
  tajikistan = ISO3166_1_Alpha3Code.TJK,
  tanzania = ISO3166_1_Alpha3Code.TZA,
  thailand = ISO3166_1_Alpha3Code.THA,
  timor_leste = ISO3166_1_Alpha3Code.TLS,
  togo = ISO3166_1_Alpha3Code.TGO,
  tokelau = ISO3166_1_Alpha3Code.TKL,
  tonga = ISO3166_1_Alpha3Code.TON,
  trinidad_tobago = ISO3166_1_Alpha3Code.TTO,
  tunisia = ISO3166_1_Alpha3Code.TUN,
  turkey = ISO3166_1_Alpha3Code.TUR,
  turkmenistan = ISO3166_1_Alpha3Code.TKM,
  turks_caicos_islands = ISO3166_1_Alpha3Code.TCA,
  tuvalu = ISO3166_1_Alpha3Code.TUV,
  uganda = ISO3166_1_Alpha3Code.UGA,
  ukraine = ISO3166_1_Alpha3Code.UKR,
  united_arab_emirates = ISO3166_1_Alpha3Code.ARE,
  united_kingdom = ISO3166_1_Alpha3Code.GBR,
  united_states = ISO3166_1_Alpha3Code.USA,
  united_states_minor_outlying_islands = ISO3166_1_Alpha3Code.UMI,
  united_states_virgin_islands = ISO3166_1_Alpha3Code.VIR,
  uruguay = ISO3166_1_Alpha3Code.URY,
  uzbekistan = ISO3166_1_Alpha3Code.UZB,
  vanuatu = ISO3166_1_Alpha3Code.VUT,
  vatican_city = ISO3166_1_Alpha3Code.VAT,
  venezuela = ISO3166_1_Alpha3Code.VEN,
  vietnam = ISO3166_1_Alpha3Code.VNM,
  wallis_futuna = ISO3166_1_Alpha3Code.WLF,
  western_sahara = ISO3166_1_Alpha3Code.ESH,
  yemen = ISO3166_1_Alpha3Code.YEM,
  zambia = ISO3166_1_Alpha3Code.ZMB,
  zimbabwe = ISO3166_1_Alpha3Code.ZWE
}

export type ISO3166_1_Alpha3 = `${ISO3166_1_Alpha3Code}` | ISO3166_1_Alpha3Code | ISO3166_1_Alpha3ByCountry;

export enum ISO3166_1_NumericCodes {
  afghanistan = "004",
  aland_islands = "248",
  albania = "008",
  algeria = "012",
  american_samoa = "016",
  andorra = "020",
  angola = "024",
  anguilla = "660",
  antarctica = "010",
  antigua_barbuda = "028",
  argentina = "032",
  armenia = "051",
  aruba = "533",
  australia = "036",
  austria = "040",
  azerbaijan = "031",
  bahamas = "044",
  bahrain = "048",
  bangladesh = "050",
  barbados = "052",
  belarus = "112",
  belgium = "056",
  belize = "084",
  benin = "204",
  bermuda = "060",
  bhutan = "064",
  bolivia = "068",
  bosnia_herzegovina = "070",
  botswana = "072",
  bouvet_island = "074",
  brazil = "076",
  british_indian_ocean_territory = "086",
  british_virgin_islands = "092",
  brunei = "096",
  bulgaria = "100",
  burkina_faso = "854",
  burundi = "108",
  cambodia = "116",
  cameroon = "120",
  canada = "124",
  cape_verde = "132",
  bonaire_sint_eustatius_saba = "535",
  cayman_islands = "136",
  central_african_republic = "140",
  chad = "148",
  chile = "152",
  china = "156",
  christmas_island = "162",
  cocos_keeling_islands = "166",
  colombia = "170",
  comoros = "174",
  cook_islands = "184",
  costa_rica = "188",
  cote_divoire = "384",
  croatia = "191",
  cuba = "192",
  curacao = "531",
  cyprus = "196",
  czechia = "203",
  denmark = "208",
  djibouti = "262",
  dominica = "212",
  dominican_republic = "214",
  dr_congo = "180",
  ecuador = "218",
  egypt = "818",
  el_salvador = "222",
  equatorial_guinea = "226",
  eritrea = "232",
  estonia = "233",
  eswatini = "748",
  ethiopia = "231",
  falkland_islands = "238",
  faroe_islands = "234",
  fiji = "242",
  finland = "246",
  france = "250",
  french_guiana = "254",
  french_polynesia = "258",
  french_southern_antarctic_lands = "260",
  gabon = "266",
  gambia = "270",
  georgia = "268",
  germany = "276",
  ghana = "288",
  gibraltar = "292",
  greece = "300",
  greenland = "304",
  grenada = "308",
  guadeloupe = "312",
  guam = "316",
  guatemala = "320",
  guernsey = "831",
  guinea = "324",
  guinea_bissau = "624",
  guyana = "328",
  haiti = "332",
  heard_island_mcdonald_islands = "334",
  honduras = "340",
  hong_kong = "344",
  hungary = "348",
  iceland = "352",
  india = "356",
  indonesia = "360",
  iran = "364",
  iraq = "368",
  ireland = "372",
  isle_of_man = "833",
  israel = "376",
  italy = "380",
  jamaica = "388",
  japan = "392",
  jersey = "832",
  jordan = "400",
  kazakhstan = "398",
  kenya = "404",
  kiribati = "296",
  kosovo = "",
  kuwait = "414",
  kyrgyzstan = "417",
  laos = "418",
  latvia = "428",
  lebanon = "422",
  lesotho = "426",
  liberia = "430",
  libya = "434",
  liechtenstein = "438",
  lithuania = "440",
  luxembourg = "442",
  macau = "446",
  madagascar = "450",
  malawi = "454",
  malaysia = "458",
  maldives = "462",
  mali = "466",
  malta = "470",
  marshall_islands = "584",
  martinique = "474",
  mauritania = "478",
  mauritius = "480",
  mayotte = "175",
  mexico = "484",
  micronesia = "583",
  moldova = "498",
  monaco = "492",
  mongolia = "496",
  montenegro = "499",
  montserrat = "500",
  morocco = "504",
  mozambique = "508",
  myanmar = "104",
  namibia = "516",
  nauru = "520",
  nepal = "524",
  netherlands = "528",
  new_caledonia = "540",
  new_zealand = "554",
  nicaragua = "558",
  niger = "562",
  nigeria = "566",
  niue = "570",
  norfolk_island = "574",
  north_korea = "408",
  north_macedonia = "807",
  northern_mariana_islands = "580",
  norway = "578",
  oman = "512",
  pakistan = "586",
  palau = "585",
  palestine = "275",
  panama = "591",
  papua_new_guinea = "598",
  paraguay = "600",
  peru = "604",
  philippines = "608",
  pitcairn_islands = "612",
  poland = "616",
  portugal = "620",
  puerto_rico = "630",
  qatar = "634",
  republic_of_congo = "178",
  reunion = "638",
  romania = "642",
  russia = "643",
  rwanda = "646",
  st_barthelemy = "652",
  st_helena_ascension_tristan_da_cunha = "654",
  st_kitts_nevis = "659",
  st_lucia = "662",
  st_martin = "663",
  st_pierre_miquelon = "666",
  st_vincent_grenadines = "670",
  samoa = "882",
  san_marino = "674",
  sao_tome_principe = "678",
  saudi_arabia = "682",
  senegal = "686",
  serbia = "688",
  seychelles = "690",
  sierra_leone = "694",
  singapore = "702",
  sint_maarten = "534",
  slovakia = "703",
  slovenia = "705",
  solomon_islands = "090",
  somalia = "706",
  south_africa = "710",
  south_georgia = "239",
  south_korea = "410",
  south_sudan = "728",
  spain = "724",
  sri_lanka = "144",
  sudan = "729",
  suriname = "740",
  svalbard_jan_mayen = "744",
  sweden = "752",
  switzerland = "756",
  syria = "760",
  taiwan = "158",
  tajikistan = "762",
  tanzania = "834",
  thailand = "764",
  timor_leste = "626",
  togo = "768",
  tokelau = "772",
  tonga = "776",
  trinidad_tobago = "780",
  tunisia = "788",
  turkey = "792",
  turkmenistan = "795",
  turks_caicos_islands = "796",
  tuvalu = "798",
  uganda = "800",
  ukraine = "804",
  united_arab_emirates = "784",
  united_kingdom = "826",
  united_states = "840",
  united_states_minor_outlying_islands = "581",
  united_states_virgin_islands = "850",
  uruguay = "858",
  uzbekistan = "860",
  vanuatu = "548",
  vatican_city = "336",
  venezuela = "862",
  vietnam = "704",
  wallis_futuna = "876",
  western_sahara = "732",
  yemen = "887",
  zambia = "894",
  zimbabwe = "716"
}
export type ISO3166_1_Numeric = `${ISO3166_1_NumericCodes}` | ISO3166_1_NumericCodes
